import React, { Component } from 'react';


import ItemDropdownField from '../../common/ItemDropdownField';


class AddItemForm extends Component {
  render() {
    const { form, excludedItems } = this.props;

    return (
      <div className="ten wide column ht-small-padding">
        <ItemDropdownField 
          name="list"
          label="Items"
          form={form}
          excludedItems={excludedItems}
        />
      </div>
    );
  }
}


export default AddItemForm;
